import { render, staticRenderFns } from "./SysConfig.vue?vue&type=template&id=4261ce56&scoped=true"
import script from "./SysConfig.vue?vue&type=script&lang=js"
export * from "./SysConfig.vue?vue&type=script&lang=js"
import style0 from "./SysConfig.vue?vue&type=style&index=0&id=4261ce56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4261ce56",
  null
  
)

export default component.exports